import Vue from 'vue'
import App from './App.vue'
import router from './router' // Imports the file we just created
import './assets/main.css'   // Ensure your Tailwind CSS is imported
import api from './services/api'

Vue.config.productionTip = false

// src/main.js
const token = localStorage.getItem('user-token');
if (token) {
  // Set the default authorization header for the lifetime of the app
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

new Vue({
  router, // Tells Vue to use the router
  render: h => h(App)
}).$mount('#app')

